const es = {
    common: {
        error: "Error",
        warning: "¡Alerta!",
        success: "Éxito",
        back: "Regresar",
        cancel: "Cancelar",
        accept: "Aceptar",
    },

    login: {
        title: "Iniciar Sesión",
        username: "Usuario",
        password: "Contraseña",
        login: "Ingresar",
        changePassword: "Cambiar Clave",
        currentPassword: "Contraseña Actual",
        newPassword: "Nueva Contraseña",
        sessionExpired: "Sesión expirada",
        yourSessionHasExpired: "Su sesión se ha expirado",
        serviceUnderMaintenance: "Servicio en mantenimiento",
        errorLogging: "Error al iniciar sesión",
        accept: "Aceptar",
    },

    navigation: {
        home: "Inicio",
        payments: "Pagos",
        certificates: "Certificados",
        accountStatus: "Estado de Cuenta",
    },

    pages: {
        login: "Iniciar Sesión",
        home: "Inicio",
        payments: "Pagos",
        certificates: "Certificados",
        accountStatus: "Estado de Cuenta",
        notFound: "Página no encontrada",
    },

    validation: {
        requiredUsername: "¡Debes escribir tu usuario!",
        requiredCurrentPassword:
            "¡Debes escribir la contraseña actual!",
        requiredNewPassword:
            "¡Debes ingresar la nueva contraseña!",
        minimumPassword:
            "¡La contraseña debe tener mínimo 6 caracteres!",
        requiredCompany:
            "¡Debes seleccionar una sociedad para iniciar sesión!",
    },

    sideBar: {
        user: "USUARIO",
        portal: "PORTAL DE",
        supplier: "PROVEEDORES",
        init: "Inicio",
        Payments: "Pagos",
        Certificates: "Certificados",
        statementOfAccount: "Estado de Cuenta",
        LogOut: "Cerrar Sesión",
    },

    certificates: {
        certificateGeneration: "Generación de Certificados",
        certificates: "Certificados",
        generateCertificate: "Generar Certificado",
        loadingTable: "Cargando tabla",
        generatingCertificate: "Generando Certificado",
        RF: "RF: Retención en la fuente renta",
        RC: "RC: Retención de Industria y Comercio",
        RV: "RV: Retención de IVA",
        SB: "SB: Sobretasa bomberil",
        CR: "CR: Retención en la fuente CREE",
        SelectionParameters: "Parámetros de Selección",
        certificateType: "Tipo de certificado",
        startPeriod: "Periodo Ini.",
        endPeriod: "Periodo Fin",
        sessionExpired: "Sesión expirada",
        yourSessionHasExpired: "Su sesión se ha expirado",
    },

    localizator: {
        NoRecordsFound: "No hay registros!",
        exportRecords: "Exportar los registros",
        search: "Buscar",
        hello: "Hola",
        records: "Registros",
        delete: "Eliminar",
        add: "Agregar",
        edit: "Editar",
        deleteTheRecord: "¿Quieres eliminar el registro?",
        save: "Guardar",
        cancel: "Cancelar",
        groupedby: "Agrupado por:",
        dragToGroup: "Deslizar caracteristica para agrupar",
        noAssociatedDocument: "No tiene retenciones asociados a este documento",
    },

    login_init: {
        welcome: "Bienvenido",
        username: "Usuario",
        password: "Contraseña",
        society: "Sociedad",
        societies: "Sociedades",
        noSocietiesFound: "No hay sociedades",
        login: "Iniciar sesión",
        rememberPassword: "Recordar Clave",
        changePassword: "Cambiar Clave",
        viewinstructions: "Ver instructivo",
        viewdetailedsupplierinstructions: "Ver instructivo detallado proveedores",
        viewdetailedinvestorguide: "Ver instructivo detallado inversionistas"
    },

    accountState: {
        supplier: "Proveedor",
        invoice: "Factura",
        invoiceDate: "Fecha fac.",
        paymentDate: "Fecha pago",
        grossAmount: "Importe bruto",
        netAmount: "Importe neto",
        currency: "Moneda",
        documentText: "Texto documento",
        sessionExpired: "Sesión expirada",
        yourSessionHasExpired: "Su sesión se ha expirado",
        functionalityBlocked: "Funcionalidad bloqueada",
        accountStatement: "Estado de cuenta - Facturas pendientes",
        listOfOutstandinInvoices: "Listado de facturas pendientes: Parámetros de selección",
        cutOffDate: "Fecha de Corte:",
        invoice: "Factura:",
        enterInvoice: "Ingresar factura",
        search: "Buscar",
        OutstandingInvoicesSummary: "Resumen facturas pendientes",
        loadingTable: "Cargando tabla",
        generateExcelFile: "Generar Archivo Excel",
        arrivedUndefined: "La data de consulta partidas abiertas llegó undefined",
    },

    accountDetail: {
        documentType: "Tipo documento",
        documentDescription: "Descripcion documento",
        amount: "Importe",
        currency: "Moneda",
        documentDetails: "Detalle del documento",
        loadingTable: "Cargando tabla",
    },

    home: {
        summary: "Resumen",
    },

    detailedAccordion: {
        paymentDate: "Fecha pago",
        paymentDocument: "Doc.pago",
        totalAmount: "Importe Total",
        currency: "Moneda",
        amount: "Importe",
        date: "Fecha",
        invoice: "Factura",
        invoiceDescription: "Descripción fact.",
        supplierData: "Datos Proveedor",
        messageSupplier: "Sr. proveedor si sus datos se encuentran desactualizados por favor enviar copia del Rut al e-mail",
        tokenExpired: "Token expiro o se cerro el back y toca reinicio las cookiens o las cookies se borraron",
        sessionExpired: "Sesión expirada",
        yourSessionHasExpired: "Su sesión se ha expirado",
        paymentList: "Listado de pagos: Parámetros de selección",
        arrivedUndefined: "La data de consulta partidas abiertas llegó undefined",
        dataPayments: "La data de consulta pagos",
        loadingTable: "Cargando tabla",
        totalAmountList: "Importe total del listado de pagos:",
        outstandingInvoices: "Facturas pendientes",
        totalAmountInvoices: "Importe total de las facturas pendientes:",
    },

    cardProfile: {
        companyAddress: "Dirección empresa:",
        city: "Ciudad",
        phone: "Teléfono:",
        mobilePhone: "Teléfono móvil:",
        email: "E-mail:",
        society: "Sociedad:",
        creditor: "Acreedor:",
        taxIdentificationNumber: "No. ident.fis.1:",
        creditorName: "Nombre acreedor:",
        companyName: "Nombre empresa:",
    },

    payments: {
        payments: "Pagos",
        paymentList: "Listado de pagos: Parámetros de selección",
        search: "Buscar",
        generateExcelFile: "Generar Archivo Excel",
        paymentsummary: "Resumen Pagos",
        loadingTable: "Cargando tabla",
        paymentDetails: "Detalle de pagos",
        supplier: "Proveedor",
        paymentDocument: "Doc.pago",
        date: "Fecha",
        amountPaidInML: "Impte.pagado en ML",
        currency: "Moneda",
        arrivedUndefined: "La data de consulta pagos llegó undefined",
        sessionExpired: "Sesión expirada",
        yourSessionHasExpired: "Su sesión se ha expirado",
        consultaPagosService: "servicio consultaPagos no responde",
        functionalityBlocked: "Funcionalidad bloqueada",
    },
    paymentsDetail: {
        supplier: "Proveedor",
        documentType: "Tipo Doc.",
        documentDescription: "Descrip. documento",
        invoice: "Factura",
        invoiceDate: "Fecha fact.",
        grossValue: "Vlr. bruto",
        vatValue: "Vlr. IVA",
        withholdingAmount: "Importe retención",
        withholdingTaxBase: "Base retención",
        percenWithholding: "% Ret.",
        netValue: "Vlr. neto",
        currency: "Moneda",
        arrivedUndefined: "La data de consulta pagos llegó undefined",
        sessionExpired: "Sesión expirada",
        yourSessionHasExpired: "Su sesión se ha expirado",
        generateCertificatesService: "servicio GenerarCertificados no responde",
    },

    datePicker: {
        date: "Fecha",
        initial: "Inicial",
        end: "Final",
        dateInitEnd: "La fecha inicial debe ser menor a la fecha final",
        searchIniEnd: "Debes ingresar la fecha inicial y final para poder buscar.",
    },

};

export default es;